import { Fragment, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { tenantSelector } from '../selector/authenticationSelector';

/**
 * Remounts everything below it whenever the selected tenant changes.
 *
 * Every RTK Query cache key carries the tenant (`api/tenantCacheKey.ts`), but
 * a query hook only re-derives WHICH key it reads when its own argument
 * changes. A hook that stays mounted across a switch and takes a
 * tenant-invariant argument — most take none — refetches under the new
 * tenant's key and keeps reading the old one, which the switch has just
 * evicted: it sits in `isLoading` with no data for good. That is how the
 * onboarded tenants vanished from the switcher after the first switch, and how
 * the topbar, sidebar and App-level gates went stale with it.
 *
 * Remounting gives every hook a fresh subscription under the current tenant,
 * and resets local UI state tied to the previous tenant along the way.
 * See `docs/architecture/tenant-scoped-caching.md`.
 */
const TenantScope = ({ children }: { children: ReactNode }) => {
    const tenant = useSelector(tenantSelector);
    return <Fragment key={tenant ?? ''}>{children}</Fragment>;
};

export default TenantScope;
